var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('transition-group',{attrs:{"name":"breadcrumb"}},_vm._l((_vm.levelList),function(item){return _c('el-breadcrumb-item',{key:item.path},[(item.redirect==='noredirect')?_c('span',[_vm._v(_vm._s(item.meta.title))]):_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(item.meta.title))])],1)}))],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b240efc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb/Breadcrumb.vue
// module id = 1604
// module chunks = 137